import React, {Component} from 'react';
import {Layout, Tabs} from 'antd';
import Header from "../../components/header";
import './care.less'

const {Content} = Layout;
const {TabPane} = Tabs;

/**
 * 人文关怀的路由组件
 */
export default class Care extends Component {

    render() {
        return (
            <Layout style={{height: '100%',overflowY:"scroll"}}>
                <Header>Header</Header>
                <Content style={{background: '#fff'}}>
                    <Tabs defaultActiveKey="1" className='care'>
                        <TabPane tab="中医望诊人文修养" key="1">
                            <div className="page_box">
                                <div className="page_con">
                                    <div className='care1'>
                                        <img src={require('./images/care1.png')}/>
                                    </div>
                                    <div className="ml50 right1">
                                        <div className="page_in">
                                            <div className="in_title page_all">1. 望情绪</div>
                                            <div className="in_body">
                                                金元医家朱丹溪首次提出“郁”在致病中的重要作用，此后医家普遍对此观点表示认同。现代医学研究发现，应激生活事件对斑秃的发生起着一定的影响。临床中医者关注患者细微的面部表情，有时也会对疾病的治疗思路起到指导作用。当患者以头部出现片状脱发就诊，并出现蹙眉或行动迟缓等抑郁焦虑状态的表现时，我们认为，对此类患者的治疗，不应单纯使用补肾、养血、生发等中药，而应借助“治未病”思想的启迪，以行气解郁为主要思路。在其临床实践中发现，运用该思路治疗斑秃，不仅片状脱发症状得以改善，而且有效阻断了患者焦虑、抑郁的情绪，同时多数患者入睡困难、多梦、早醒等症状也会有明显的改善。
                                            </div>
                                        </div>
                                        <div className="page_in">
                                            <div className="on_title page_all">2. 望七情与精神状态</div>
                                            <div className="in_body">
                                                望诊有助于临床医生对患者的个体情况进行更详尽地了解，以便指导用药或者及早发现患者的焦虑抑郁状态，以干预可能由于负面情绪心理改变而引发的继发疾病。《灵枢·本脏》曰:
                                                “视其外应，以知其内脏，则知所病矣。”基于望诊时发现失眠患者大多出现眼眶周围发黑,舌尖多红赤或有点刺等临床表现，吴喜庆等认为失眠与患者长期的焦虑抑郁等负面情绪心理改变相关，以“疏肝解郁”为主要治疗方法取得了良好地治疗效果。以上案例提示诊疗时，医生应高度重视患者心理情绪改变，并运用相应方法进行“治神”，有助于疾病临床早日痊愈。
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tab="营造良好的人文诊疗环境" key="2">
                            <div className="page_box">
                                <div className="page_con">
                                    <div className='left2'>
                                        <div className="page_in">
                                            <div className="in_title page_all">1. 诊室自然环境</div>
                                            <div className="in_body">
                                                室内温度适宜，通风、采光良好。环境干净、整洁，无明显污迹，背景清新典雅。物品分类摆放，井然有序，各归其位。如果诊室卫生状况堪忧，物品摆放凌乱，会引发患者对医生的卫生专业资质和医疗思维是否存在混乱的疑忌。
                                            </div>
                                        </div>
                                        <div className="page_in">
                                            <div className="on_title page_all">2. 诊室人文环境</div>
                                            <div className="in_body">
                                                诊疗环境设置要求私密性强，避免环境漏洞造成患者隐私泄露。在当前大陆中医诊室，一人就诊、多人围观的开放式诊疗环境非常普遍。开放式诊疗环境导致医患双方无法交流与病情相关的患者隐私，导致疾病漏诊误诊而影响疗效；有时患者之间因隐私保护问题发生纠纷；部分患者因隐私得不到保障而不予就医。为加强隐私保护，中医门诊就诊制度可参考CT、MRI等大型医疗仪器检查科室的工作流程，有条件的医疗机构可设立专门的医生助理或护士维持诊疗秩序，做到一人就诊，众人按秩序候诊，从而最大限度保护患者隐私。医务人员应平心静气、彬彬有礼地与非当前应诊患者沟通，说明尊重和保护患者隐私的重要性，敬请非应诊患者于诊室门外候诊，杜绝无关人等围观，形成中医门诊的规范性就诊流程。
                                            </div>
                                        </div>
                                    </div>
                                    <div className='care2'>
                                        <img src={require('./images/care2.png')}/>
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tab="医患沟通的人文修养" key="3">
                            <div className="page_box">
                                <div className="page_con mb50 care3">
                                    <div className="mr50" style={{marginRight: 130}}>
                                        <img src={require('./images/care3.png')} style={{width: 331, height: 391}}/>
                                    </div>
                                    <div
                                        className="page_txt">加强医患沟通，表达关爱友善。借助于脉诊信息，将脉诊和四诊有机融合，能够增加病人的信任程度，坚定患者治愈疾病的信心。我国目前处于“低度信任社会”时期，频发的医疗纠纷导致医患双方相互戒备，患着更加相信“朋友”、“熟人”而不是陌生的医务人员能够全心全意地帮助自己。因此，医生应站在患者角度，加强医患沟通；出于帮助病人度过难关的立场，表达自己的关爱友善；把病人视为自己的熟人、朋友，拉近双方距离，能够迅速地改善医患双方的信任程度，也为患者的诊疗服从性打下基础。
                                    </div>
                                </div>
                                <div className="page_con middle3">
                                    <div style={{width: '100%'}}>
                                        <div className="page_info_box">
                                            <div className="page_all box_title_in">1. 医生情绪及专注程度体现中医学的人文关怀</div>
                                            <div className="box_body">
                                                <ul>
                                                    <li>（1）情绪稳定 （2）专心致志 全神贯注</li>
                                                    <li>（3）医生的表情、动作、语言等细节体现中医学的人文关怀</li>
                                                </ul>
                                            </div>

                                        </div>
                                        <div className="page_info_box mr0">
                                            <div className="page_all box_title_on">2. 诊室人文环境</div>
                                            <div className="box_body">
                                                <ul>
                                                    <li>（1）一视同仁 平等对待</li>
                                                    <li>（2）重视患者的心理体验</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tab="四诊操作规范的人文修养" key="4">
                            <div className="page_box box4">
                                <div className="page_con care4">
                                    <div className="page_txt">
                                        提高四诊技能，熟悉四诊诊疗规范。利用精湛的医术最大限度地解除患者病痛，是中医学人文关怀的出发点和落脚点。高明的中医大夫望诊能够做到“望而知之谓之神”，脉诊能够做到“手摸心会、法从手出”，诊断方法专业规范熟练，诊断结果与患者症状体征切合度高，能够给患者治愈有望的积极心理暗示，减轻患者心理负担，改善患者的负面消极情绪。倘若诊断方法不熟练、诊断结果与病症的切合度低，容易导致患者怀疑医生的诊疗水平并影响最终的治疗效果。《苏沈良方·脉说》“至虚有盛候，大实有羸状。差之毫厘疑似之间，便有死生祸福之异”。《大医精诚》：“寸口关尺有浮沉弦紧之乱，穴流注有高下浅深之差，肌肤筋骨有浓薄刚柔之异，唯用心精微者，始可与言于兹矣”。中医望诊、脉诊技能精微巧妙，面诊和脉象体会幽晦难明，不经过刻苦训练，用心体会，很难得心应手。脉诊操作流程规范，手法专业熟练，无论患者就诊多少次，每次脉诊的流程相同，持续时间相近；严厉杜绝初次就诊就不予脉诊的恶劣医疗行为；也不能因患者多次就诊，以对其脉象已经掌握而不进行脉诊或者简化脉诊流程及时间。
                                    </div>
                                </div>
                                <div className="page_con middle4">
                                    <div className="page_info_box">
                                        <div className="other_title"> 四诊操作要求</div>
                                        <div className="other">
                                            <ul>
                                                <li>
                                                    （1）着装要求
                                                </li>
                                                <li>
                                                    （2）卫生要求
                                                </li>
                                                <li>
                                                    （3）指甲要求
                                                </li>
                                                <li>
                                                    （4）指温要求
                                                </li>
                                                <li>
                                                    （5）体位要求
                                                </li>
                                                <li>
                                                    （6）脉诊力度要求
                                                </li>
                                                <li>
                                                    （7）脉诊时间要求
                                                </li>
                                                <li>
                                                    （8）季节变化要求
                                                </li>
                                                <li>
                                                    （9）脉枕使用要求
                                                </li>
                                                <li>
                                                    （10）佩戴首饰、手表等物品的要求
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div style={{width:"40%",marginLeft:"50px"}}>
                                        <img src={require('./images/care4.png')}/>
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tab="中医四诊人文故事" key="5">
                            <div className="page_box">
                                <div className="page_con mb50 care5">
                                    <div className="mr50">
                                        <img src={require('./images/care5.png')} style={{width:205,height:192}}/>
                                    </div>
                                    <div
                                        className="page_txt"> 中医之诊病，依望闻问切，当四诊合参。然切脉一诊，凭指下应感，断吉‘凶预后，切切不可马虎从事，人云亦云。名医黄元御“游心于虚静之宇，动指于冲漠之庭，以此测病，亦不啻鬼谋而神告己”之教诲，乃脉诊造诣之根本。
                                    </div>
                                </div>
                                <div className="page_con middle5">
                                    <div className="page_in">
                                        <div className="page_all last_title">麻瑞亭四诊合参，脉诊一绝</div>
                                        <div className="in_body">
                                            <p>
                                                1978年，麻瑞亭赴京城探望其次女，居女家。其女时在北京某中学任教。某日，其女曰：“我校校长，欲来家请你为其一诊。”麻问曰：“其素有疾否？”女曰：“其正盛壮之年，精力充沛，未闻其有疾。”
                                            </p>
                                            <p>
                                                次日，该校长如约至其女家。麻瑞亭为其诊脉后，日：“你右腿有小恙，余度你患过小儿麻痹。”其女先愕然，因该校长步履如常人，从未闻其患过小儿麻痹之疾。然该校长却朗声大笑，曰：“老先生真神！我确实曾患小儿麻痹症，患于右腿。幸当时治疗及时，无明显后遗症，因之不但同事们不知，亲朋们也多不知。”其女惊问：“何以断其患过小儿麻痹，且系右腿？”麻答日：“咱家院门至屋门约20米，听其到来，出屋相迎，见其右腿稍不灵活，若不在意，必然忽视。后诊其脉，右关尺较大，且右尺脉独涩，乃右腿有疾之候。汝言其素健无病，吾见之确系体健，故断其右腿为宿疾。业医数10年中，见类似之脉证，而系小儿麻痹所致者有之，故断言之。”
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </TabPane>
                    </Tabs>
                </Content>
            </Layout>
        )
    }
}